
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/info/[pathName]",
      function () {
        return require("private-next-pages/info/[pathName].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/info/[pathName]"])
      });
    }
  